import React from "react";
import {
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

import styles from "./ConfigVariableList.module.css";

export type EnvironmentPermission = {
  user: string;
  role: "owner" | "write" | "read_only";
};

export default function EnvironmentPermissionList(props: {
  permissions: EnvironmentPermission[];
  onPermissionsUpdate: (permissions: EnvironmentPermission[]) => Promise<any>;
}) {
  const setOwner = (permission: EnvironmentPermission, isOwner: boolean) => {
    const index = props.permissions.findIndex(
      (p) => p.user === permission.user
    );
    const newPermissions = [...props.permissions];
    newPermissions[index].role = isOwner ? "owner" : "write";
    props.onPermissionsUpdate(newPermissions);
  };

  const setWrite = (permission: EnvironmentPermission, isWrite: boolean) => {
    const index = props.permissions.findIndex(
      (p) => p.user === permission.user
    );
    const newPermissions = [...props.permissions];
    newPermissions[index].role = isWrite ? "write" : "read_only";
    props.onPermissionsUpdate(newPermissions);
  };

  return (
    <>
      <TableContainer component={Paper} variant="outlined">
        <Table className={styles.variablesTable}>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Is Owner</TableCell>
              <TableCell>Write access</TableCell>
              <TableCell>Read access</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...props.permissions].map((permission) => (
              <TableRow>
                <TableCell>{permission.user}</TableCell>
                <TableCell>
                  <Switch
                    checked={permission.role === "owner"}
                    onChange={(e) => setOwner(permission, e.target.checked)}
                  />
                </TableCell>
                <TableCell>
                  <Switch
                    checked={
                      permission.role === "owner" || permission.role === "write"
                    }
                    onChange={(e) => setWrite(permission, e.target.checked)}
                    disabled={permission.role === "owner"}
                  />
                </TableCell>
                <TableCell>
                  <Switch checked disabled />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
